const MESSAGES: Record<string, string> = {
  google_not_configured: "La connexion Google n’est pas encore active.",
  popup_blocked: "Le navigateur a bloqué la fenêtre de connexion. Autorisez les fenêtres, puis réessayez.",
  server: "La connexion n’a pas pu démarrer. Réessayez.",
  google_not_connected: "Connectez d’abord Google pour accéder à vos fiches.",
  google_denied: "La connexion Google a été annulée.",
  google_token_failed: "Google n’a pas renvoyé de jeton. Réessayez.",
  meta_not_configured: "La connexion Facebook n’est pas encore active.",
  meta_denied: "La connexion Facebook a été annulée.",
  meta_token_failed: "Facebook n’a pas renvoyé de jeton. Réessayez.",
  meta_no_page: "Aucune Page Facebook n’a été autorisée. Choisissez au moins une Page.",
  google_api: "Google n’a pas accepté la requête. Réessayez dans un instant.",
  unauthorized: "Session expirée. Reconnectez-vous à la Suite.",
  missing_location: "Choisissez une fiche établissement.",
  missing_review: "Avis introuvable.",
  missing_comment: "Écrivez une réponse avant d’envoyer.",
  missing_group: "Donnez un nom au groupe.",
  google_quota: "Google n’accepte pas encore l’écriture. Enregistré en aperçu.",
  missing_photo: "Choisissez une photo JPEG, PNG ou WebP.",
  photo_too_big: "La photo dépasse 8 Mo.",
  photo_write: "La photo n’a pas pu être enregistrée.",
  missing_action: "Type et lien https requis.",
  missing_reply_name: "Donnez un nom à la réponse.",
  missing_reply_text: "Écrivez le texte de la réponse enregistrée.",
  reply_limit: "Cinq réponses enregistrées maximum.",
  missing_account: "Ajoutez ou choisissez un compte Facebook ou Instagram.",
  missing_post: "Écrivez un texte ou ajoutez un visuel.",
  missing_schedule: "Indiquez le jour et l’heure de planification.",
  bad_media: "Format non pris en charge. JPEG, PNG, WebP, MP4 ou MOV.",
  video_too_big: "La vidéo dépasse 100 Mo.",
  library_write: "Le média n’a pas pu être enregistré. Réessayez.",
  missing_media: "Ce média n’est plus dans la médiathèque.",
  social_write: "La publication n’a pas pu être enregistrée.",
  instagram_media: "Instagram demande un visuel. Téléversez ou choisissez un média.",
};

export function humanError(err: unknown): string {
  const raw = err instanceof Error ? err.message : String(err || "");
  return MESSAGES[raw] || "Une erreur s’est produite. Réessayez.";
}
